import type {
  AnalyticsEnhancer,
  Datalayer,
  DatalayerInputEvent,
  PageInfo,
} from '@analytics/models';
import { InjectionToken, type Type } from '@angular/core';
import type { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import type { AnalyticsEnhancerSources } from './analytics-enhancer-sources.service';

export const withPageTrackEnhancers =
  (sources: AnalyticsEnhancerSources, datalayer: Datalayer) =>
  (source$: Observable<PageInfo>) =>
    source$.pipe(
      concatMap((event) => sources.enhancePageInfo(event, datalayer))
    );

export const withEventTrackEnhancers =
  (sources: AnalyticsEnhancerSources, datalayer: Datalayer) =>
  (source$: Observable<DatalayerInputEvent>) =>
    source$.pipe(
      concatMap((event) => sources.enhanceEventTrack(event, datalayer))
    );

export const ANALYTICS_ENHANCERS = new InjectionToken<
  Type<AnalyticsEnhancer>[]
>('core/analytics: Enhancers');
